import _moment from "../../libs/moment"
import AppLocale from "../../config/lang"
const dateRange = (props) => {
  const customRange = props?.range?? {}
  const customFrom = props?.from?? {}
  const customTo = props?.to?? {}
  const hasCustomRangeOnChange = typeof customRange.onChange === "function"

  const rangeName = customRange.name?? "range"
  const fromName = customFrom.name?? "from"
  const toName = customTo.name?? "to"
  const autoToUpdateFlagName = `${rangeName}_${toName}_autoUpdate`

  const defaultOptionsFormFilter = [
    {value: 0, label: "main.lastWeek"},
    {value: 1, label: "main.lastMonth"},
    {value: 2, label: "main.custom"}
  ]

  const defaultOptionsFormCreateUpdate = [
    {value: 0, label: "main.onlyForToday"},
    {value: 1, label: "main.oneWeekfromToday"},
    {value: 2, label: "main.oneMonthFromToday"},
    {value: 3, label: "main.anotherDateRange"}
  ]

  const defaultOnChangeFormFilter = (ctx) => {
    if (ctx.state[rangeName] === 0) ctx.setState({
      [fromName]: _moment().add(-7, 'days').format('YYYY-MM-DD'),
      [toName]: _moment().format('YYYY-MM-DD')
    })
    else if (ctx.state[rangeName] === 1) ctx.setState({
      [fromName]: _moment().add(-30, 'days').format('YYYY-MM-DD'),
      [toName]: _moment().format('YYYY-MM-DD')
    })
    else ctx.setState({[fromName]: null, [toName]: null})
  }

  const getBaseFrom = (ctx) => {
    const currentFrom = ctx.state[fromName]
    return currentFrom && _moment(currentFrom).isValid() ? _moment(currentFrom) : _moment()
  }

  const getDateLabel = (ctx) => {
    const locale = ctx?.props?.locale || "en"
    const L = AppLocale[locale]?.messages || {}
    const baseFrom = getBaseFrom(ctx)
    if (baseFrom.isSame(_moment(), "day")) return (L["main.today"] || "today").toLowerCase()
    return baseFrom.locale(locale === "es" ? "es" : "en").format("DD-MMM")
  }

  const getLocalizedLabel = (ctx, labelKey) => {
    const locale = ctx?.props?.locale || "en"
    const template = AppLocale[locale]?.messages?.[labelKey] || labelKey
    return template.replace("{0}", getDateLabel(ctx))
  }

  const setProgrammaticToValues = (ctx, values) => {
    ctx.setState({ [autoToUpdateFlagName]: true, ...values }, () => {
      ctx.setState({ [autoToUpdateFlagName]: false })
    })
  }

  const defaultOnChangeFormCreateUpdate = (ctx) => {
    const baseFrom = getBaseFrom(ctx)

    if (ctx.state[rangeName] === 0) {
      setProgrammaticToValues(ctx, {
        [fromName]: baseFrom.clone().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        [toName]: baseFrom.clone().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      })
    }
    else if (ctx.state[rangeName] === 1) {
      setProgrammaticToValues(ctx, {
        [fromName]: baseFrom.format('YYYY-MM-DD'),
        [toName]: baseFrom.clone().add(+7, 'days').format('YYYY-MM-DD')
      })
    }
    else if (ctx.state[rangeName] === 2) {
      setProgrammaticToValues(ctx, {
        [fromName]: baseFrom.format('YYYY-MM-DD'),
        [toName]: baseFrom.clone().add(+30, 'days').format('YYYY-MM-DD')
      })
    }
    else if (ctx.state[rangeName] === 3) ctx.setState({[fromName]: null, [toName]: null})
  }

  const defaultOnChangeFromFormCreateUpdate = (ctx) => {
    if (hasCustomRangeOnChange) {
      customRange.onChange(ctx)
      return
    }

    const selectedRange = ctx.state[rangeName]
    const currentFrom = ctx.state[fromName]
    if ((selectedRange !== 0 && selectedRange !== 1 && selectedRange !== 2) || !currentFrom || !_moment(currentFrom).isValid()) return

    const baseFrom = _moment(currentFrom)
    if (selectedRange === 0) setProgrammaticToValues(ctx, { [toName]: baseFrom.clone().endOf('day').format('YYYY-MM-DD HH:mm:ss') })
    else if (selectedRange === 1) setProgrammaticToValues(ctx, { [toName]: baseFrom.clone().add(+7, 'days').format('YYYY-MM-DD') })
    else if (selectedRange === 2) setProgrammaticToValues(ctx, { [toName]: baseFrom.clone().add(+30, 'days').format('YYYY-MM-DD') })
  }

  const defaultOnChangeToFormCreateUpdate = (ctx) => {
    if (ctx.state[autoToUpdateFlagName]) return
    if (ctx.state[rangeName] !== 3) ctx.setState({ [rangeName]: 3 })
  }

  const getDefaultRangePresetFromDates = (from, to) => {
    if (!from || !to || !_moment(from).isValid() || !_moment(to).isValid()) return null

    const fromDate = _moment(from)
    const toDate = _moment(to)

    if (fromDate.isSame(toDate, "day")) return 0
    if (toDate.isSame(fromDate.clone().add(+7, "days"), "day")) return 1
    if (toDate.isSame(fromDate.clone().add(+30, "days"), "day")) return 2

    return 3
  }

  const resolveRangeFromDates = (ctx) => {
    const fromValue = ctx.state[fromName]
    const toValue = ctx.state[toName]

    const customResolver = customRange?.opts?.resolveValueFromDates || customRange.resolveValueFromDates
    const resolved = typeof customResolver === "function"
      ? customResolver({ ctx, from: fromValue, to: toValue, rangeName, fromName, toName, moment: _moment })
      : getDefaultRangePresetFromDates(fromValue, toValue)

    if (resolved === null || resolved === undefined) return null

    const availableItems = customRange?.opts?.itemsF
      ? customRange.opts.itemsF(ctx) || []
      : (customRange?.opts?.items || [])
    if (availableItems.length <= 0) return resolved

    const matched = availableItems.find((item) => item?.value === resolved)
    return matched ? resolved : null
  }

  const syncRangeFromDatesIfNeeded = (ctx) => {
    if (!props?.isFormCrud) return
    if (ctx.state[rangeName] !== null && ctx.state[rangeName] !== undefined && ctx.state[rangeName] !== "") return

    const resolvedRange = resolveRangeFromDates(ctx)
    if (resolvedRange === null || resolvedRange === undefined) return

    ctx.setState({ [rangeName]: resolvedRange })
  }

  const items = props?.isFormCrud ? defaultOptionsFormCreateUpdate : defaultOptionsFormFilter
  const onChange = props?.isFormCrud ? defaultOnChangeFormCreateUpdate : defaultOnChangeFormFilter

  let range = {
    name: rangeName,
    value: null,
    type: "select",
    label: "main.dateRange",
    placeholder: "main.dateRange",
    opts: {
      style: 'float-label',
      items: items,
      ...(props?.isFormCrud ? {
        itemsF: (ctx) => defaultOptionsFormCreateUpdate.map((item) => ({
          value: item.value,
          label: getLocalizedLabel(ctx, item.label)
        }))
      } : {})
    },
    onChange: onChange
  }

  const rangeOpts = range.opts?? {}
  const customRangeOpts = customRange.opts?? {}
  range = {...range, ...customRange}
  range.opts = {...rangeOpts, ...customRangeOpts}
  const rangeRenderIf = range.renderIf
  range.renderIf = (ctx) => {
    syncRangeFromDatesIfNeeded(ctx)
    return rangeRenderIf ? rangeRenderIf(ctx) : true
  }

  let from = {
    name: fromName,
    value: null,
    type: "date",
    label: "main.from",
    opts: {
      style: 'float-label',
      selectsStart: true,
      startDate: (ctx) => ctx.state[fromName] ? _moment(ctx.state[fromName]) : null,
      endDate: (ctx) => ctx.state[toName] ? _moment(ctx.state[toName]) : null
    },
    renderIf: props?.isFormCrud 
      ? ctx => (ctx.state[fromName] || ctx.state[rangeName] === 3) && (range.renderIf ? range.renderIf(ctx) : true)
      : ctx => ctx.state[rangeName] === 2 && (range.renderIf ? range.renderIf(ctx) : true)
  }
  if (props?.isFormCrud) from.onChange = defaultOnChangeFromFormCreateUpdate

  const fromOpts = from.opts?? {}
  const customFromOpts = customFrom.opts?? {}
  from = {...from, ...customFrom}
  from.opts = {...fromOpts, ...customFromOpts}

  let to = {
    name: toName,
    value: null,
    type: "date",
    label: "main.to",
    opts: {
      style: 'float-label',
      selectsEnd: true,
      startDate: (ctx) => _moment(ctx.state[fromName]),
      endDate: (ctx) => _moment(ctx.state[toName]),
      minDate: (ctx) => _moment(ctx.state[fromName])
    },
    renderIf: props?.isFormCrud 
    ? ctx => (ctx.state[toName] || (ctx.state[rangeName] === 3 && ctx.state[fromName])) && (range.renderIf ? range.renderIf(ctx) : true)
    : ctx => (ctx.state[rangeName] === 2 && ctx.state[fromName]) && (range.renderIf ? range.renderIf(ctx) : true)
  }
  if (props?.isFormCrud) to.onChange = defaultOnChangeToFormCreateUpdate

  const toOpts = to.opts?? {}
  const customToOpts = customTo.opts?? {}
  to = {...to, ...customTo}
  to.opts = {...toOpts, ...customToOpts}

  const fieldsByKey = { range, from, to }
  const orderedKeysFromConfig = Object.keys(props || {}).filter((key) => Object.prototype.hasOwnProperty.call(fieldsByKey, key))
  const fallbackKeys = ["range", "from", "to"].filter((key) => !orderedKeysFromConfig.includes(key))
  const orderedKeys = [...orderedKeysFromConfig, ...fallbackKeys]

  return orderedKeys.map((key) => fieldsByKey[key])
}
export default dateRange